import { z } from 'zod';
import { ROLES, Role } from './roles.js';
import { USER_GROUPS, UserGroup } from './group.js';
/**
 * Branch Chairs post in their own branch, so they need one; a Branch Chair of the diaspora
 * posts abroad (country and city on each activity) and has no branch in Albania.
 */
const branchRule = {
    message: 'Për kryetarin e degës zgjidhni qarkun, bashkinë dhe degën.',
    path: ['municipalityId'],
};
export const userCreateSchema = z
    .object({
    email: z.string().trim().toLowerCase().email('Adresa e emailit nuk duket e saktë.'),
    fullName: z.string().trim().min(3).max(150),
    phone: z.string().trim().max(30).optional(),
    title: z.string().trim().max(150).optional(),
    role: z.enum(ROLES),
    group: z.enum(USER_GROUPS).optional(),
    countyId: z.string().uuid().optional(),
    municipalityId: z.string().uuid().optional(),
    unitId: z.string().uuid().optional(),
})
    .refine((u) => u.role !== Role.BRANCH_CHAIR ||
    u.group === UserGroup.DIASPORA ||
    (u.countyId && u.municipalityId), branchRule);
export const userUpdateSchema = z.object({
    fullName: z.string().trim().min(3).max(150).optional(),
    phone: z.string().trim().max(30).nullable().optional(),
    title: z.string().trim().max(150).nullable().optional(),
    role: z.enum(ROLES).optional(),
    group: z.enum(USER_GROUPS).nullable().optional(),
    countyId: z.string().uuid().nullable().optional(),
    municipalityId: z.string().uuid().nullable().optional(),
    unitId: z.string().uuid().nullable().optional(),
    isActive: z.boolean().optional(),
});
//# sourceMappingURL=user.js.map